import { AbstractControl } from '@angular/forms';

export default function telefoneVerdadeiro(control: AbstractControl): { [key: string]: any } | null {
    var strTelefone = control.value.replace(/[()_-]/g, '');
    return strTelefone.length >= (strTelefone.substr(3,1) === '9' ? 13 : 11) ? null : { telefoneValido: true };
}